import { PF_PUBLIC_ID_COOKIE_NAME } from 'consts/storageConsts';

import { trackClaimWithChimePayAnyone } from 'utils/segment/trackingEvents';

import cookies from './cookies';

export const shouldTrackPfPublicIdCookie = () => {
  const paiTokenFromCookie = cookies.get(PF_PUBLIC_ID_COOKIE_NAME);
  if (paiTokenFromCookie) {
    trackClaimWithChimePayAnyone(paiTokenFromCookie);
  }
};
